module.exports = __webpack_public_path__ + "img/icon_home.b31feca.webp";